/**
 * What an order's page is opened to do, as its address holds it. The top
 * bar's search offers "hand to another specialist": the page then opens with
 * that question asked already (`?do=assign`), if the visit still allows it.
 */
export interface OrderSearch {
  do?: "assign";
}

/** Reads the address. Anything it does not know is dropped, never trusted. */
export function parseOrderSearch(raw: Readonly<Record<string, unknown>>): OrderSearch {
  return raw["do"] === "assign" ? { do: "assign" } : {};
}
